export default __webpack_public_path__ + "static/media/kubilay.0de4bb26.svg";